import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Badge, Button, Container, ProgressBar } from 'react-bootstrap';
import { BetaBadge } from '../../components/BetaBadge/BetaBadge';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useEffect, useMemo, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { formatSecondsTimestamp } from '../../utils/utils';

const StripeDashboardComponent = () => {
  const { getStripeDashboard, manageCache } = useFirebase();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const nf = useMemo(() => {
    if ('Intl' in window) return new Intl.NumberFormat('it-IT', { style: 'decimal' });
    return {
      format(x) {
        return x;
      },
    };
  }, []);

  useEffect(() => {
    getStripeDashboard()
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <FullscreenLoader />;

  return (
    <>
      <Title>Stripe Dashboard</Title>

      <Topbar />

      <Container className={'my-5'}>
        <div className={'display-4 mb-5'}>
          Stripe Dashboard
          <BetaBadge big />
        </div>

        <Alert variant={'info'} className={'mb-5'}>
          L'ultimo aggiornamento dei seguenti dati risale al: <strong>{formatSecondsTimestamp(Math.floor(data.updated / 1000), 'dd/MM/y HH:mm')}</strong>
          <br />
          <Button
            as={Badge}
            onClick={async () => {
              setLoading(true);
              await manageCache(`DEL_REDIS_KEY`, 'stripeDashboard')();
              window.location.reload();
            }}
          >
            Clicca qui
          </Button>{' '}
          per ottenere i dati aggiornati (il caricamento sarà più lento).
        </Alert>

        <h5 className={'mb-4'}>
          Totale utenti iscritti: <strong>{nf.format(data.customersCount)}</strong>
        </h5>

        <h5>Rapporto utenti paganti / utenti gratuiti</h5>
        <ProgressBar className={'rounded-pill'}>
          <ProgressBar variant={'primary'} min={0} max={data.customersCount} now={data.subscriptionsCount} label={nf.format(data.subscriptionsCount)} />
          <ProgressBar
            variant={'dark'}
            min={0}
            max={data.customersCount}
            now={data.customersCount - data.subscriptionsCount}
            label={nf.format(data.customersCount - data.subscriptionsCount)}
          />
        </ProgressBar>
        <div className={'mt-2'}>
          Tasso di conversione: <strong>{data.conversionRate}%</strong>
        </div>

        <details className={'mt-5 text-muted'}>
          <summary>Raw data</summary>
          <pre className={'mb-0'}>{JSON.stringify(data, null, 2)}</pre>
        </details>
      </Container>

      <Footer />
    </>
  );
};

export default StripeDashboardComponent;
